import React from 'react';
import Typography from '@mui/material/Typography';
import {ChipSamplesTable} from './ChipSamplesTable';
import {ReviewContainer} from './ReviewContainer';

interface ChipReviewProps {
    samples: any[];
    experiment: Readonly<any>;
    errors: {missingFiles: string[]; duplicateName: string[]; fileStatus: string[]};
    reFetchSamples: () => Promise<void>;
    expectedFilenamesBySampleId?: Record<string, string[]>;
}

/**
 * Shows up to three tables of samples: Control (Input), IP with control, and IP without control.
 */
export const ChipReview: React.FC<ChipReviewProps> = ({samples, experiment, errors, reFetchSamples, expectedFilenamesBySampleId}) => {
    const errorIds = new Set(Object.values(errors).flat());
    const controlSamples = samples.filter(sample => sample.other_categories.SampleType === 'Input');
    const ipControl = samples.filter(
        sample => sample.other_categories.SampleType === 'IP' && sample.other_categories.ControlName !== 'NoControl'
    );
    const controlNameToSample: Record<string, any> = {};
    controlSamples.forEach(sample => {
        controlNameToSample[sample.name] = sample;
    });
    const ipNoControl = samples.filter(
        sample => sample.other_categories.SampleType === 'IP' && sample.other_categories.ControlName === 'NoControl'
    );

    // Define the three tables, if there are samples to place in them.
    let Controls = null;
    let IP = null;
    let NoControl = null;
    if (controlSamples.length > 0) {
        Controls = (
            <>
                <Typography variant="h4" sx={{my: 1}}>
                    Controls
                </Typography>
                <ChipSamplesTable
                    samples={controlSamples}
                    experiment={experiment}
                    errorIds={errorIds}
                    onChangeCompleted={reFetchSamples}
                    expectedFilenamesBySampleId={expectedFilenamesBySampleId}
                />
            </>
        );
    }
    if (ipControl.length > 0) {
        IP = (
            <>
                <Typography variant="h4" sx={{my: 1}}>
                    IP with Control
                </Typography>
                <ChipSamplesTable
                    samples={ipControl}
                    experiment={experiment}
                    controls={controlNameToSample}
                    errorIds={errorIds}
                    onChangeCompleted={reFetchSamples}
                    expectedFilenamesBySampleId={expectedFilenamesBySampleId}
                />
            </>
        );
    }
    if (ipNoControl.length > 0) {
        NoControl = (
            <>
                <Typography variant="h4" sx={{my: 1}}>
                    IP without Control
                </Typography>
                <ChipSamplesTable
                    samples={ipNoControl}
                    experiment={experiment}
                    errorIds={errorIds}
                    onChangeCompleted={reFetchSamples}
                    expectedFilenamesBySampleId={expectedFilenamesBySampleId}
                />
            </>
        );
    }

    return (
        <ReviewContainer>
            {Controls}
            {IP}
            {NoControl}
        </ReviewContainer>
    );
};
